import React from 'react';
import { Dialog, DialogContent, IconButton, Typography, Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface DeleteBeneficiaryDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteBeneficiaryDialog: React.FC<DeleteBeneficiaryDialogProps> = ({ open, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{
      sx: { borderRadius: 3, padding: 2 },
    }}
  >
    <IconButton onClick={onClose} sx={{ position: 'absolute', right: 16, top: 16, color: '#444' }}>
      <CloseIcon />
    </IconButton>
    <DialogContent>
      <Typography variant="h6" align="center" sx={{ color: '#e0004d', fontWeight: 600, mb: 4 }}>
        Confirmação de desativação.
      </Typography>
      <Box display="flex" justifyContent="center" gap={3}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            minWidth: 160,
            borderRadius: 999,
            textTransform: 'none',
            fontWeight: 500,
            borderColor: '#1a4fd8',
            color: '#1a4fd8',
            '&:hover': { borderColor: '#1a4fd8', backgroundColor: 'rgba(26,79,216,0.04)' },
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="outlined"
          onClick={onConfirm}
          sx={{
            minWidth: 160,
            borderRadius: 999,
            textTransform: 'none',
            fontWeight: 500,
            borderColor: '#e0004d',
            color: '#e0004d',
            '&:hover': { borderColor: '#e0004d', backgroundColor: 'rgba(224,0,77,0.04)' },
          }}
        >
          Desativar
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);

export default DeleteBeneficiaryDialog;
